/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcRemoveCircleFill({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M1.1 12C1.1 5.98 5.98 1.1 12 1.1S22.9 5.98 22.9 12 18.02 22.9 12 22.9 1.1 18.02 1.1 12m6.455-.9a.9.9 0 1 0 0 1.8h8.89a.9.9 0 0 0 0-1.8z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcRemoveCircleFill;
